import { BedDouble, Bus, Plane, Utensils, type LucideIcon } from 'lucide-react';

// The passenger card's SERVICES by sight (PO 2026-11-01: «al usuario le gusta ver
// dibujitos, no leer tanto»): each one its own icon and hue — the same on its card and on
// its cell of the trip strip — so the eye finds the flight, the meals or the hotel before
// reading a word. Identity, not state: the hues stay clear of the status colours
// (airport-tokens.ts: emerald ok, amber warn, rose alert, indigo info), which still say
// where each service stands. Drawn by `ServiceIcon` / `ServiceCard` (pnr-card-ui.tsx).

export type PnrService = 'flight' | 'meals' | 'hotel' | 'transfer';

export interface IServiceLook {
  icon: LucideIcon;
  /** The icon's tile beside a card's title: soft surface, the hue on the glyph. */
  tile: string;
  /** The hue alone — a small icon inside a line. */
  text: string;
  /** The card's stripe down its left edge. */
  stripe: string;
}

const SKY: Omit<IServiceLook, 'icon'> = {
  tile: 'bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300',
  text: 'text-sky-600 dark:text-sky-400',
  stripe: 'bg-sky-500',
};
const ORANGE: Omit<IServiceLook, 'icon'> = {
  tile: 'bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300',
  text: 'text-orange-600 dark:text-orange-400',
  stripe: 'bg-orange-500',
};
// The hotel and its transfer share one card, so one hue; the bus tells them apart.
const VIOLET: Omit<IServiceLook, 'icon'> = {
  tile: 'bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300',
  text: 'text-violet-600 dark:text-violet-400',
  stripe: 'bg-violet-500',
};

export const SERVICE_LOOK: Readonly<Record<PnrService, IServiceLook>> = {
  flight: { icon: Plane, ...SKY },
  meals: { icon: Utensils, ...ORANGE },
  hotel: { icon: BedDouble, ...VIOLET },
  transfer: { icon: Bus, ...VIOLET },
};
